import { render } from "./NewPassword.vue?vue&type=template&id=9daa32a4&scoped=true&ts=true"
import script from "./NewPassword.vue?vue&type=script&lang=ts"
export * from "./NewPassword.vue?vue&type=script&lang=ts"

import "./NewPassword.vue?vue&type=style&index=0&id=9daa32a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9daa32a4"]])

export default __exports__